import React, { Fragment } from 'react';
import { DISTRIBUTION, HAZARDS, LONGITS } from './common';
import Chart from 'react-google-charts';

const AllCharts = (props) => {
  const {type, existingHazards} = {...props}
  const getLongitChartOptions = () => {
    return {
      title: 'Age vs Biomarker value and Hazard rate',
      curveType: "none",
      legend: { position: 'top' },
      series: {
        0: { 
          targetAxisIndex: 0, // First Y-axis (Response Time)
          color: '#3366CC',
          lineWidth: 3
        },
        1: { 
          targetAxisIndex: 1, // Second Y-axis (Requests)
          color: '#DC3912',
          lineWidth: 3,
          // lineDashStyle: [4, 1] // Optional: makes line dashed
        },
      },
      vAxes: {
        // First Y-axis (Response Time)
        0: { 
          title: 'Biomarker Value',
          textStyle: { color: '#3366CC' },
          titleTextStyle: { color: '#3366CC' }
        },
        // Second Y-axis (Requests)
        1: { 
          title: 'Hazard Rates',
          textStyle: { color: '#DC3912' },
          titleTextStyle: { color: '#DC3912' },
          format: 'short'
        }
      },
      hAxis: {
        title: 'Age',
        slantedText: true,
        slantedTextAngle: 45
      },
      chartArea: {
        width: '80%',
        height: '70%'
      },
      tooltip: { 
        isHtml: true,
        
      }
    }
  };
  
  const getLongitChartData = () => {
    const data = [["Age","BioMarker Value","Hazard Rates"]];

    for(let i=0;i<existingHazards.length;i++) {
      data.push([
        existingHazards[i]['age'],
        existingHazards[i]['modelBiomarkerValue'], 
        existingHazards[i]['hazardRate']
      ]);
    } 
  
    return data;
    // return [["abc","sada","ccc"],[20,2,5],[21,4,7],[22,6,9],[23,8,7], [24,9,11]];
  }
  const getHazardChartData = () => {
    const data = [["BioMarker Value","Hazard Rates"]];

    for(let i=0;i<existingHazards.length;i++) {
      data.push([
        existingHazards[i]['biomarkerValue'], 
        existingHazards[i]['hazardRate']
      ]);
    } 

    return data;
    // return [["abc","sada","ccc"],[20,2,5],[21,4,7],[22,6,9],[23,8,7], [24,9,11]];
  }

  const getHazardChartOptions = () => {
    return {
      title: 'Biomarker value vs Hazard rate',
      curveType: "none",
      legend: { position: 'top' },
      series: {
        // 0: { 
        //   targetAxisIndex: 0, // First Y-axis (Response Time)
        //   color: '#3366CC',
        //   lineWidth: 3
        // },
        0: { 
          targetAxisIndex: 1, // Second Y-axis (Requests)
          color: '#DC3912',
          lineWidth: 3,
          // lineDashStyle: [4, 1] // Optional: makes line dashed
        },
      },
      vAxes: {
        // First Y-axis (Response Time)
        
        // Second Y-axis (Requests)
        0: { 
          title: 'Hazard Rates',
          textStyle: { color: '#DC3912' },
          titleTextStyle: { color: '#DC3912' },
          format: 'short'
        }
      },
      hAxis: {
        title: 'Biomarker',
        slantedText: true,
        slantedTextAngle: 45
      },
      chartArea: {
        width: '80%',
        height: '70%'
      },
      tooltip: { 
        isHtml: true,
        
      }
    }
  };
  return ( 
    <Fragment>
      {
        type === LONGITS && 
        <Chart
          width="100%"
          height="400px"    
          chartType="LineChart"
          data={getLongitChartData()}
          options={getLongitChartOptions()}
          loader={<div>Drawing Chart</div>}
        />
      }
      {
        type === HAZARDS &&
        <Chart
          width="100%"
          height="400px"    
          chartType="LineChart"
          data={getHazardChartData()}
          options={getHazardChartOptions()}
          loader={<div>Drawing Chart</div>}
        />
      }
      {
        type === DISTRIBUTION &&
        <div> Under Construction </div>
      }
      
    </Fragment>
  ) 
}

export default AllCharts;